import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  textProductName: {
    fontSize: 18,
    fontWeight: '700',
    textAlign: 'center',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  noStockMessage: {
    fontSize: 16,
    fontWeight: '700',
    color: '#ff5050',
    lineHeight: 24,
    textAlign: 'center',
    marginVertical: 5,
  },
  cardItemLarge: {
    width: '95%',
    marginTop: 15,
    backgroundColor: '#001C47',
    paddingVertical: 15,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'space-between',
    borderRadius: 5,
  },
  cardItemSmall: {
    width: '90%',
    marginTop: 15,
    backgroundColor: '#001C47',
    paddingVertical: 8,
    paddingHorizontal: 8,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'space-between',
    borderRadius: 5,
  },
  controlQuantityContainer: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-end',
    marginRight: 15,
  },
  productNameContainer: {
    alignSelf: 'center',
    justifyContent: 'flex-start',
    flex: 1,
  },
  iconDefault: {
    marginTop: 2,
    alignSelf: 'center',
  },
  containerIcon: {
    backgroundColor: '#fff',
    borderRadius: 25,
    paddingHorizontal: 8,
    paddingVertical: 5,
  },
  disabledIconStyle: {
    backgroundColor: '#FFFFFF',
  },
  productQuantity: {
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 24,
    letterSpacing: 0,
    textAlign: 'center',
    alignSelf: 'center',
  },
  productQuantityContainerSmall: {
    backgroundColor: '#fff',
    justifyContent: 'center',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 9,
    marginLeft: 5,
    marginRight: 5,
  },
  productQuantityContainerLarge: {
    backgroundColor: '#fff',
    justifyContent: 'center',
    borderRadius: 8,
    paddingVertical: 9,
    paddingHorizontal: 15,
    marginLeft: 5,
    marginRight: 5,
  },
});
